module.exports = __webpack_public_path__ + "img/upload-file.0aed046b.svg";